document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.js-tabs');
    tabs.forEach((link, i) => {
        const tabbg = link.parentElement.querySelector('.tabs-nav__bg');
        const tabid = link.getAttribute('href').slice(1);
        const tabblock = link.getAttribute('data-tab-block');
        const items = document.querySelectorAll(
            `#${tabblock} .tabs-items__item`
        );
        tabbg.style.width = `${100 / items.length}%`;

        let bgpos = 0;
        if (link.classList.contains('tabs-nav__link--active')) {
            bgpos = i * 100;
        }

        tabbg.style.transform = `translate3d(${bgpos}%,0,0)`;
        setTimeout(() => {
            tabbg.style.transition =
                'transform 0.15s cubic-bezier(0.2, 0, 0.5, 1)';
        }, 100);

        link.addEventListener('click', (e) => {
            e.preventDefault();
            if (!link.classList.contains('tabs-nav__link--active')) {
                const linkactive = link.parentElement.querySelector(
                    '.tabs-nav__link--active'
                );
                linkactive.classList.remove('tabs-nav__link--active');
                link.classList.add('tabs-nav__link--active');

                history.pushState({}, '', `#${tabid}`);

                items.forEach((item, index) => {
                    item.classList.remove('tabs-items__item--active');
                    const id = item.getAttribute('id');
                    if (tabid === id) {
                        item.classList.add('tabs-items__item--active');
                        bgpos = 100 * index;
                        tabbg.style.transform = `translate3d(${bgpos}%,0,0)`;
                    }
                });
            }

            // console.log(value);
        });
    });

    // Active tab on load page
    const { hash } = window.location;
    const linkHash = document.querySelector(`.js-tabs[href="${hash}"]`);
    if (typeof linkHash !== 'undefined' && linkHash !== null) {
        linkHash.dispatchEvent(new Event('click'));
    }

    // Active tab on click back/forward page
    window.addEventListener('hashchange', function () {
        const { hash } = window.location;
        const linkHash = document.querySelector(`.js-tabs[href="${hash}"]`);
        if (typeof linkHash !== 'undefined' && linkHash !== null) {
            linkHash.dispatchEvent(new Event('click'));
        }
    });
});
